import type { AxiosRequestConfig } from 'axios';
import http from 'http';
import https from 'https';
import { getLang } from 'utils/actionLang';
import { getToken } from 'utils/actionToken';

const headers: any = {
  'Content-Type': 'application/json;charset=UTF-8',
  'X-Requested-With': 'XMLHttpRequest',
  lang: getLang(),
};

const token = getToken();
if (token) {
  headers['token'] = token;
}

const config: AxiosRequestConfig = {
  headers: headers,
  timeout: 1000 * 60,
  withCredentials: true,
  responseType: 'json',
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  // 用于node.js
  httpAgent: new http.Agent({
    keepAlive: true,
  }),
  httpsAgent: new https.Agent({
    keepAlive: true,
  }),
};

export default config;
